/**
 * sha256.ts — F-003.4 Phase 4 (IMPL-P4-001).
 *
 * Compute SHA-256 hex digest of a string using the Web Crypto API.
 * Used to hash the consent text before submitting a pratica, so the
 * server can audit the exact text the user accepted without storing
 * the plaintext in the audit log.
 */
export async function sha256Hex(text: string): Promise<string> {
  const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(text));
  return Array.from(new Uint8Array(buf))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}
